<template>
  <div class="add-pay-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="350px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="100px" :label-position="labelPosition">
          <el-form-item label="图片:">
            <base-upload  :cover="params.img" :action="action" @successCallback="successCallback" :wSize="360" :hSize="640" :width="'180px'" :height="'90px'"></base-upload>
          </el-form-item>          
          <el-form-item label="标题:">
            <el-input v-model="params.title" size="small"></el-input>
          </el-form-item>
          <el-form-item label="跳转方式:" prop="hrefType">
              <el-select v-model.number="params.hrefType" size="small" placeholder="跳转方式">
                <el-option
                  v-for="item in hrefTypeList"
                  :value="item.value"
                  :label="item.label"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <div class="protocol" v-if="params.hrefType!==2">
              <span>提示:地址协议请使用</span>
              <span
                style="color:red"
              >{{this.protocolType=params.hrefType===0?'http或https':'yinselink或yinselinks'}}</span>
            </div>          
          <el-form-item label="链接地址:">
              <el-select
                v-show="params.hrefType===2 "
                v-model.number="params.url"
                size="small"
                placeholder="请选择跳转地址"
                clearable
              >
                <el-option
                  v-for="item in hrefList"
                  :value="item.value"
                  :label="item.label"
                  :key="item.value"
                ></el-option>
              </el-select>            
             <el-input
                v-show="params.hrefType!==2"
                v-model="params.url"
                size="small"
                placeholder="请输入链接地址"
              ></el-input>              
          </el-form-item>
          <el-form-item label="是否激活:">
          <el-switch v-model="params.isActive"></el-switch>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submit('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '@/api'
import baseConfig from '@/utils/serverUrlConfig'
export default {
  data() {
    return {
      type:'',
      dialogVisible: false,
      title: '',
      flag: false,
      labelPosition: 'left',
      params: {
        id: '',
        title: '',
        img: '',
        hrefType:'',
        url:'',
        isActive:false
      },
      hrefTypeList: [
        { label: "外部浏览器跳转", value: 0 },
        { label: "内部浏览器跳转", value: 1 },
        { label: "APP内部跳转", value: 2 },
      ], 
      hrefList: [
        { label: "个性名片(推广界面)", value: "yinseinner://personal_card/" },
        { label: "VIP界面", value: "yinseinner://vip_page/" },
        { label: "钱包界面", value: "yinseinner://wallet_page/" },
        { label: "全民代理", value: "yinseinner://universal_agent/" },
      ],           
      rules: {
         hrefType: [
          { required: true, message: "请选择链接类型", trigger: "blur" },
        ],
        href: [
          { message: "请输入正确的Url", trigger: "blur" },
          { validator: this.urlSchemes, trigger: "blur" },
        ],
      },
      action: baseConfig.baseServerUrl + '/agent/upload/static',  // 图片上传地址
    }
  },

  methods: {
    // 提交修改
    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if(this.type==='edit'){
            this.updateLfAd()
            this.flag = false
          }else{
            this.addLfAd() 
             this.flag = false
          }

        }
      })
    },
    // 修改
    updateLfAd() {
      API.updateLfAd(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: '修改成功',
              type: 'success',
            })
            this.$emit('handlerChannelList')
          } else {
            this.$message.error('修改失败')
          }
          this.flag = false
          this.handleClose()
        })
        .catch(() => {
          this.flag = false
          this.handleClose()
        })
    },
    //添加
    addLfAd() {
      API.addLfAd(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: '新增成功',
              type: 'success'
            })
            this.$emit('handlerChannelList')
          } else {
            this.$message.error('新增失败')
          }
          this.flag = false
          this.handleClose()
        })
        .catch(() => {
          this.flag = false
          this.handleClose()
        })
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.params = {
        id: '',
        title: '',
        img: '',
        url:'',
        hrefType:'',
        isActive:false
      }
      this.$refs['form'].resetFields()
    },

    // 封面图上传成功回调
    successCallback(res) {
      this.params.img=res.data.coverImg
    },
    //url地址验证
    urlSchemes(rule, value, callback) {
      let reg;
      switch (this.params.hrefType) {
        case 0:
          reg = /(http|https):\/\/([\w.]+\/?)\S*/gi;
          break;
        case 1:
          reg = /(yinselink|yinselinks):\/\/([\w.]+\/?)\S*/gi;
          break;
        case 2:
          reg = /yinseinner:\/\/([\w.]+\/?)\S*/gi;
          break;
      }
      if (reg.test(value) || !value) {
        callback();
      } else {
        callback(new Error("请输入有效地址"));
      }
    },
    urlhrefType(rule, value, callback) {
      let err = undefined;
      let reg;
      if (this.params.href !== "") {
        switch (value) {
          case 0:
            reg = /(http|https):\/\/([\w.]+\/?)\S*/gi;
            break;
          case 1:
            reg = /(yinselink|yinselinks):\/\/([\w.]+\/?)\S*/gi;
            break;
          case 2:
            reg = /yinseinner:\/\/([\w.]+\/?)\S*/gi;
            break;
        }
        if (!reg.test(this.params.href)) {
          switch (value) {
            case 0:
              err = new Error("请使用 http或https 协议");
              break;
            case 1:
              err = new Error("请使用 yinselink或yinselinks 协议");
              break;
            case 2:
              err = new Error("请选择跳转链接");
              break;
            default:
              err = new Error("URL格式不正确");
          }
        }
      }
      callback(err);
    },    
    // 打开编辑视频弹窗、传递需要编辑的参k
    open(type,data) {
      this.type=type
      this.dialogVisible = true
      if(this.type==='edit'){
      this.params = data
      window.console.log(data,'000')
      this.title = '修改楼凤广告配置'
      }else{
         this.title = '新增楼凤广告配置'
      }

    },
  },
}
</script>

<style lang="scss" scoped>
.add-pay-box {
  .el-date-picker,
  .el-input {
    width: 150px;
  }
  .form_item {
    margin-top: 10px;
  }
      .protocol {
        font-size: 10px;
        margin-left: 10px;
        color: green;
      }  
}
</style>


style>